import { useMemo } from 'react';
import type { ScreenState } from '@hana/ui';
import { LEARNERS, type Learner, type Viewer } from './data/courses';

const STATES: readonly ScreenState[] = ['ready', 'loading', 'empty', 'error', 'noperm'];

export interface EduAccess {
  learner: Learner;
  /** Ép trạng thái màn như prop `state` của board (xem thử / chụp ảnh). */
  state: ScreenState;
  /** prop `state=noperm` của board = "vai không có quyền": màn học vẫn hiện như ready, chỉ bỏ quyền quản lý + số đếm. */
  noperm: boolean;
}

/** TODO(A): người đăng nhập thật đến từ phiên Office 365 khi luồng A có; tạm đọc `?viewer=DAVID|MAITTN&state=…` như prop của board. */
export function useEdu(search: string = typeof location === 'undefined' ? '' : location.search): EduAccess {
  return useMemo(() => eduAccess(search), [search]);
}

/** Phần thuần của useEdu (đọc như prop board `viewer` / `state`). */
export function eduAccess(search: string): EduAccess {
  const p = new URLSearchParams(search);
  const v = p.get('viewer') as Viewer | null;
  const st = p.get('state') as ScreenState | null;
  const learner = LEARNERS[v && v in LEARNERS ? v : 'DAVID'];
  const state: ScreenState = st && STATES.includes(st) ? st : 'ready';
  // board Mint-Training: `ready = pstate === 'ready' || pstate === 'noperm'`, `canMgr = me.mgr && pstate !== 'noperm'`
  if (state === 'noperm') return { learner: { ...learner, manager: false }, state: 'ready', noperm: true };
  return { learner, state, noperm: false };
}
